import React, { useEffect } from 'react';
import Modal from '../../../components/Modal';
import LenderUgroService from '../../../services/lender';
import MasterDataService from '../../../services/master-data';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import message from '../../../constant/message';
import Button from '../../../components/Common/Button';

const SubmitToLender = ({
	modelState,
	detailLenderId,
	detailLenderName,
	toggleModal,
	getLeadDetail,
	detailsResponse={}
}) => {
	const navigate = useNavigate();
	const { state } = React.useContext(Context);
	const [loading1, setLoading1] = React.useState(false);
	const [loading2, setLoading2] = React.useState(false);
	const [loading3, setLoading3] = React.useState(false);
	const leadId = useParams()['id'];
	const [otp, setOTP] = React.useState('');
	const [sendOTP, setSendOTP] = React.useState(false);
	const [time, setTime] = React.useState(0);
	const [timerId, setTimerId] = React.useState(null);
	const [validate, setValidate] = React.useState(false);
	const [gstIn, setGstIn] = React.useState('');
	const [gstUsername, setGstUsername] = React.useState('');


	const submitToLender = async () => {
		try {
			if(detailsResponse?.is_jocata_req && otp.length !=6){
				toast.error('Incorrect OTP, Please enter the correct OTP.');
				return;
			}
			setLoading2(true);
			/** Check branch Validation to mas lender **/
			const lenderIds = [8];
			if (lenderIds.includes(Number(detailLenderId))) {
				let branchStatus = await MasterDataService.getBranchList('admin','co-lender',leadId,detailLenderName);
				if (!branchStatus?.data?.data?.branch) {
					toast.error(`Case is not eligible for ${detailLenderName} lender as the sourcing branch did not match the master branch approved by ${detailLenderName}`);
					setLoading2(false);
					return;
				}
			}
			/** Check branch Validation to mas lender end **/
			const response = await LenderUgroService.submitToLender(
				state.userType,
				'co-lender',
				leadId,
				detailLenderId,
				otp,
				gstUsername
			);
			getLeadDetail();
			const success = response?.data?.messages?.success;
			toast.success(
				success?.form?.[0] || success?.others?.[0] || message.SAVED_SUCCESS
			);
			navigate('/portfolio/pending');
		} catch (err) {
			let error = err?.response?.data?.messages?.error;
			toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
		}
		setLoading2(false);
	};

	const validateLeadBeforeOTP = async () => {
		try {
			setLoading2(true);
			let leadResData = await MasterDataService.getLAF(
				'admin',
				'co-lender',
				leadId
			)
			setGstIn(leadResData?.data?.data?.lead?.gst_in || '');

			const response = await LenderUgroService.jocataSendOTP(
				state.userType,
				'co-lender',
				leadId,
				detailLenderId,
				gstUsername,
				1
			);
			// const success = response?.data?.messages?.success;
			// toast.success(
			// 	success?.form?.[0] || success?.others?.[0]
			// );
			setValidate(true);
		} catch (err) {
			let error = err?.response?.data?.messages?.error;
			toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
		}
		setLoading2(false);
	};

	const jocataSendOTP = async () => {
		try {
			if(!gstIn){
				toast.error('GST Number is required to generate OTP.');
				return;
			}
			if(!sendOTP){
				setLoading1(true);
			}else{
				setLoading3(true)
			}
			toast.info('We are processing your request, Please wait...');
			const response = await LenderUgroService.jocataSendOTP(
				state.userType,
				'co-lender',
				leadId,
				detailLenderId,
				gstUsername,
				0
			);
			const success = response?.data?.messages?.success;
			toast.success(
				success?.form?.[0] || success?.others?.[0]
			);
			startTimer();
			setSendOTP(true);
		} catch (err) {
			if(!sendOTP){
				setSendOTP(false);
			}
			let error = err?.response?.data?.messages?.error;
			toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
			setTime(0)
		}
		setLoading1(false);
		setLoading3(false);
	};

	const startTimer = (sec=180) => {
		clearInterval(timerId)
		setTime(sec)
		let intervalId = setInterval(() => {
			setTime(time => {
				const newCount = time - 1;
				return newCount;
			  });
		}, 1000);
		setTimerId(intervalId)
	}

	useEffect(()=> {
		if (time <= 0) {
			clearInterval(timerId)
			setTimerId(null)
		}
	}, [time])

	return (
		<Modal state={modelState} closeModal={toggleModal} removeBorderSpace={true} closeOnOverlayClick={false}>
			<div className="modal-header-container">
				<div className="modal-title">{(detailsResponse?.is_jocata_req && validate ? 'JOCATA SCORE' : 'Submit to Lender')} ({detailLenderName})</div>
				<div className="closeModalView" onClick={toggleModal}>
					<span className="closeModalIcon">x</span>
				</div>
			</div>
			{detailsResponse?.is_jocata_req && validate ?
				<div class='p-3'>
					<div className='table-responsive' style={{textAlign: 'center', margin: '12px 0'}}>
						<table className="table table-striped jocata-table" style={{display: 'inline'}}>
							<tbody>
								<tr>
									<td>GST Username</td>
									<td>
										<input
											class='form-control custom-form-control'
											value={gstUsername}
											maxLength={100}
											disabled={sendOTP}
											onChange={(e) => setGstUsername(e.target.value)}
											required
										/>
									</td>
								</tr>
								<tr height='37'>
									<td>GST Number</td>
									<td>{gstIn || '---'}</td>
								</tr>
								<tr>
									<td>Action</td>
									<td>
										<div className='d-flex align-items-center justify-content-center'>
											<Button clickHandler={jocataSendOTP} classNames='btn-custom small' disabled={sendOTP || !gstUsername || loading1}>
												{loading1 ? <div className='loader' /> : 'Send OTP'}
											</Button>
										</div>
									</td>
								</tr>
								{sendOTP && <tr style={{display:(sendOTP ? 'table-row' : 'none')}}>
									<td>Enter OTP</td>
									<td>
										<input
											class='form-control custom-form-control'
											value={otp}
											maxLength={6}
											style={{'letter-spacing': '1px', 'width': '85px', 'margin-left': '64px'}}
											onChange={(e) => setOTP(e.target.value.replace(/\D/g, ''))}
											required
										/>
										{!timerId ?
											(loading3 ? <div style={{float: 'right', marginTop: '-13px'}} className='loader' /> : <span className='resend' onClick={jocataSendOTP}>Resend</span>)
											: <span className='resend'>{time} <i class="fa fa-clock-o"></i></span>
										}
									</td>
								</tr>}
							</tbody>
						</table>
					</div>
					{sendOTP && <div className='d-flex align-items-center justify-content-center'>
						<Button clickHandler={submitToLender} classNames='btn-custom small' disabled={otp.length != 6 || loading2}>
							{loading2 ? <div className='loader' /> : 'Submit OTP'}
						</Button>
					</div>}
				</div>
			:
				<div class='p-3'>
					<p className='font-weight-bold text-center'>
						Do you really want to submit this application to the{' '}
						{detailLenderName}?
					</p>
					<div className='d-flex align-items-center justify-content-center'>
						<Button
							clickHandler={toggleModal}
							classNames='btn-custom small mr-2 mt-2'
						>
							No
						</Button>
						<Button clickHandler={detailsResponse?.is_jocata_req ? validateLeadBeforeOTP : submitToLender} classNames='btn-custom small mt-2' disabled={loading2}>
							{loading2 ? <div className='loader' /> : 'Yes'}
						</Button>
					</div>
				</div>
			}
		</Modal>
	);
};

export default SubmitToLender;
